import React, { useEffect, useState } from "react";
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { FiChevronRight, FiChevronLeft, FiChevronsRight } from 'react-icons/fi'
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { formatCurrency } from "../../utils/currencyUtils";
import { useCurrency } from "../../hooks/useCurrency"

const Products = ({ title, products }) => {
    const { userInfo } = useSelector((state) => state.auth);
    const { currencyCode, exchangeLoaded } = useCurrency()
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    }

    const ButtonGroup = ({ next, previous }) => {
        return (
            <div className='flex justify-between items-center'>
                <div className='text-lg font-bold text-gray-900'>{title}</div>
                <div className='flex justify-center items-center gap-3 text-slate-600'>
                    <button onClick={() => previous()} className='w-[30px] h-[30px] flex justify-center items-center text-gray-700 rounded-sm bg-gray-100 hover:bg-gray-200 font-semibold'>
                        <span><FiChevronLeft /></span>
                    </button>
                    <button onClick={() => next()} className='w-[30px] h-[30px] flex justify-center items-center text-gray-700 rounded-sm bg-gray-100 hover:bg-gray-200 font-semibold'>
                        <span><FiChevronRight /></span>
                    </button>
                </div>
            </div>
        )
    }
    return (
        <div className='flex gap-8 flex-col-reverse'>
            <Carousel
                autoPlay={false}
                infinite={false}
                arrows={false}
                responsive={responsive}
                transitionDuration={500}
                renderButtonGroupOutside={true}
                customButtonGroup={<ButtonGroup />}

            >
                {
                    products.map((p, i) => {
                        return (
                            <div key={i} className='flex flex-col justify-start gap-2 '>
                                {
                                    p.map((pl, j) => <Link key={j}  to={`/product/details/${pl._id}`} className='flex justify-start rounded-md items-start bg-white border border-gray-100 p-2 mb-2' >
                                        <img className='w-[80px] h-[80px] rounded-md nex_img_cover' src={pl.images[0]} alt="images" />
                                        <div className='px-3 flex justify-start items-start gap-1 flex-col text-gray-900'>
                                            <h2 className='text-[13px]'>{pl.name?.slice(0, 40)}</h2>
                                            <span className='text-md font-bold'> {formatCurrency(pl.price, currencyCode, exchangeLoaded)}</span>
                                            <p className='text-[13px]'>{pl.description?.slice(0, 40)}...</p>
                                        </div>

                                    </Link>)
                                }
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}

export default Products